import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

import logo from '../assets/img/logo.png';
import loginVectorImg from '../assets/img/login-vector.svg';
import { login } from '../services/loginServices';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Login() {
  const [form, setForm] = useState({
    username: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const [errorMsg, setErrorMsg] = useState('');
  const[showPassword, setShowPassword] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (!form.username ) {
      if (!errors.username) newErrors.username = "Username is required";
    }
    if (!form.password) newErrors.password = "Password is required";  

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };

  const handleChange = (e) => { setForm({ ...form, [e.target.name]: e.target.value });
    setErrorMsg('');
    setErrors({});
};
  const submit = async (event) => {
    
    event.preventDefault();
     if (!validateForm()) {
        return
      }
    event.stopPropagation();
    const response = await login(form);
    if (response && response.token) {
      localStorage.setItem('token', response.token);
      localStorage.setItem('cms_sub_domain',response.cms_subdomain);
      localStorage.setItem('cms_private_key',response.private_key);
      if(localStorage.getItem('token')) {
        window.location.href = '/homeslider';
      }      
    } else if (response && response.error) {
      setErrorMsg(response.error); 
    }
  }
  const required = true;
  return (
    <div data-theme="default" data-layout="fluid" data-sidebar-position="left" data-sidebar-layout="default">
      <main className="d-flex w-100 min-vh-100 bg-dark align-items-center justify-content-center">
      <div className="container py-5">
        <div className="row justify-content-center align-items-center">
          {/* Image Column */}
          <div className="col-lg-6 d-none d-lg-block">
            <img
              src={loginVectorImg}
              alt="login right illustration"
              className="img-fluid"
              style={{ maxHeight: '500px', objectFit: 'contain' }}
            />
          </div>

          {/* Form Column */}
          <div className="col-12 col-md-10 col-lg-6">
            <div className="text-center mb-4">
              <img
                src={logo}
                alt="Scientex Conferences"
                className="img-fluid"
                style={{ maxWidth: '240px' }}
              />
            </div>

            {errorMsg && (
              <div className="alert alert-danger mt-2 p-3" role="alert">
                {errorMsg}
              </div>
            )}

            <div className="card shadow">
              <div className="card-body p-4">
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                      Username <small className="text-danger">*</small>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="username"
                      value={form.username}
                      onChange={handleChange}
                      placeholder="Enter your username"
                      required
                      isInvalid={!!errorMsg || !!errors.username}
                    />
                    <Form.Control.Feedback type="invalid">{errors.username}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3 position-relative">
                    <Form.Label className="fw-bold">
                      Password <small className="text-danger">*</small>
                    </Form.Label>
                    <Form.Control
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                      required
                      isInvalid={!!errorMsg || !!errors.password}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: 'absolute',
                        top: '45%',
                        right: '20px',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        zIndex: 2,
                      }}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                    <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>

                    <small>
                      <p className="mt-3">
                        <small className="text-danger">*</small> Contact Admin for Password Reset
                      </p>
                    </small>
                  </Form.Group>

                  <div className="d-grid mt-4">
                    <button className="btn btn-lg btn-primary" onClick={submit}>
                      Sign in
                    </button>
                  </div>
                </Form>
              </div>
            </div>

            <div className="text-center mt-4 text-light">
              Welcome to Scientex Conferences CMS Portal
            </div>
          </div>
        </div>
      </div>
    </main>
    </div>
  );
}

export default Login;